import { render, staticRenderFns } from "./IconConiclex.vue?vue&type=template&id=fcf2bc52"
import script from "./IconConiclex.vue?vue&type=script&lang=js"
export * from "./IconConiclex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports